var path = '/app/pages/logout/logout.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/logout/logout.html
// module id = 1109
// module chunks = 0